import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles.css';

const el = document.getElementById('cml-calculator-root');

// فقط اگه المنت وجود داره و هنوز React رویش mount نشده
if (el && !el.dataset.mounted) {
  const root = ReactDOM.createRoot(el);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
  el.dataset.mounted = 'true';
}
